<!--光伏电站-逆变器信息-->
<template>
  <el-row :gutter="gutter30">
    <!-- 左边遥测值开始 -->
    <el-col :span="9">
      <div class="el-button-history-container">
        <el-button type="text" @click="inverterMethods().left.history.openDialog()">{{ historyText }}</el-button>
      </div>
      <el-table :data="left.pvList" style="width: 100%;">
        <el-table-column prop="pv" label="输入回路"></el-table-column>
        <el-table-column prop="vpv" :label="UTitle"></el-table-column>
        <el-table-column prop="pvCurr" :label="ITitle"></el-table-column>
        <el-table-column prop="ppv" :label="PTitle"></el-table-column>
      </el-table>
      <el-dialog title="直流侧历史数据" :visible.sync="left.dialog.dialogVisible" :width="dialogWidth"
                 :before-close="inverterMethods().left.dialog.handleClose">
        <date-picker-with-export @prevDayClick="inverterMethods().left.history.findDeviceTskvFromChild($event)"
                                 @nextDayClick="inverterMethods().left.history.findDeviceTskvFromChild($event)"
                                 @searchClick="inverterMethods().left.history.findDeviceTskvFromChild($event)">
          <template v-slot:default>
            <el-button type="primary" size="small" plain icon="el-icon-download" style="margin-top:5px"
                       v-if="judgeAuthority('zixitong:guangfu:photovoltaicStation:export')"
                       @click="inverterMethods().left.dialog.exportExcel()">EXCEL
            </el-button>
          </template>
        </date-picker-with-export>
        <my-divider :height="myDividerHeight15"></my-divider>
        <el-row :gutter="gutter10">
          <el-col :span="3">
            <el-menu ref="menu" :default-active="left.dialog.menu.defaultActive"
                     @open="inverterMethods().left.dialog.menu.handleOpen"
                     @close="inverterMethods().left.dialog.menu.handleClose">
              <el-menu-item :index="(index + 1).toString()" v-for="(item, index) in left.pvList"
                            :key="index" @click="inverterMethods().left.dialog.menu.menuSelected(item)">
                <span slot="title">{{ item.pv }}</span>
              </el-menu-item>
            </el-menu>
          </el-col>
          <el-col :span="21">
            <el-row>
              <el-col :span="12">
                <el-radio-group v-model="left.dialog.radioGroupUIP.radioUIP" size="mini"
                                @change="inverterMethods().left.dialog.radioGroupUIP.radioUIPChange($event)">
                  <el-radio-button :label="item" v-for="(item,index) in left.dialog.telemetryCategory"
                                   :key="index"></el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <el-radio-group v-model="left.dialog.radioGroupUIP.radioType" size="mini">
                  <el-radio-button :label="value" v-for="(value,index) in showStyle" :key="index"></el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <my-divider :height="myDividerHeight10"></my-divider>
            <div v-show="left.dialog.echarts.chartsData.xData.length > 0">
              <div class="echartsBox" v-show="left.dialog.radioGroupUIP.radioType === showStyle.echarts">
                <OmitLine :id="'lineBoxLeft'" :chartsData="left.dialog.echarts.chartsData"/>
              </div>
              <div v-show="left.dialog.radioGroupUIP.radioType === showStyle.table">
                <data-table-with-two-columns title-x="时间"
                                             :title-y="dataTableTitleLeft"
                                             :data-source-x="left.dialog.echarts.tableData.xDataTable"
                                             :data-source-y="left.dialog.echarts.tableData.yDataTable"></data-table-with-two-columns>
              </div>
            </div>
            <el-empty description="无数据" v-show="left.dialog.echarts.chartsData.xData.length === 0"></el-empty>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer"><el-button type="primary" @click="left.dialog.dialogVisible = false">关 闭</el-button></span>
      </el-dialog>
    </el-col>
    <!-- 左边遥测值结束 -->

    <!-- 中间属性开始 -->
    <el-col :span="6">
      <my-divider :height="myDividerHeight35"></my-divider>
      <h3 class="title-1"> {{ attributesTitle }}</h3>
      <div class="attribute">
        <table class="description-1">
          <tr class="description-1" v-for="item in info.attributeNameValues">
            <td class="name-description-1">{{ item.name }}</td>
            <td class="separator-description-1"></td>
            <td class="value-description-1">{{ item.value }}</td>
          </tr>
        </table>
        <my-divider :height="myDividerHeight20"></my-divider>
        <el-row class="el-row-refresh">
          <el-col :span="8">
            <img src="@/assets/images/xitong/dc.png" class="ac-dc" alt="DC"/>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="inverterMethods().getInverterData()">刷新</el-button>
          </el-col>
          <el-col :span="8">
            <img src="@/assets/images/xitong/ac.png" class="ac-dc" alt="AC"/>
          </el-col>
        </el-row>
      </div>
    </el-col>
    <!-- 中间属性结束 -->

    <!-- 右边遥测值开始 -->
    <el-col :span="9">
      <div class="el-button-history-container">
        <el-button type="text" @click="inverterMethods().right.history.openDialog()">{{ historyText }}</el-button>
      </div>
      <table class="right">
        <tr>
          <td>参数</td>
          <td>{{ phase.A }}</td>
          <td>{{ phase.B }}</td>
          <td>{{ phase.C }}</td>
        </tr>
        <tr>
          <td>{{ UTitle }}</td>
          <td>{{ info.telemetry['UA'] }}</td>
          <td>{{ info.telemetry['UB'] }}</td>
          <td>{{ info.telemetry['UC'] }}</td>
        </tr>
        <tr>
          <td>{{ ITitle }}</td>
          <td>{{ info.telemetry['IA'] }}</td>
          <td>{{ info.telemetry['IB'] }}</td>
          <td>{{ info.telemetry['IC'] }}</td>
        </tr>
        <tr>
          <td>有功功率/{{ unit.P }}</td>
          <td>{{ info.telemetry['PA'] }}</td>
          <td>{{ info.telemetry['PB'] }}</td>
          <td>{{ info.telemetry['PC'] }}</td>
        </tr>
        <tr>
          <td>总有功功率/{{ unit.P }}</td>
          <td colspan="3">{{ info.telemetry['Power'] }}</td>
        </tr>
        <tr>
          <td>{{ zh_cn.PF }}</td>
          <td colspan="3">{{ info.telemetry['PF'] }}</td>
        </tr>
        <tr>
          <td>{{ zh_cn.Fac }}/{{ unit.Fac }}</td>
          <td colspan="3">{{ info.telemetry['Fac'] }}</td>
        </tr>
      </table>
      <el-dialog title="交流侧历史数据" :visible.sync="right.dialog.dialogVisible" :width="dialogWidth"
                 :before-close="inverterMethods().right.dialog.handleClose">
        <date-picker-with-export @prevDayClick="inverterMethods().right.history.findDeviceTskvFromChild($event)"
                                 @nextDayClick="inverterMethods().right.history.findDeviceTskvFromChild($event)"
                                 @searchClick="inverterMethods().right.history.findDeviceTskvFromChild($event)">
          <template v-slot:default>
            <el-button type="primary" plain size="small" v-if="judgeAuthority('zixitong:guangfu:photovoltaicStation:export')"
                       icon="el-icon-download" style="margin-top:5px"
                       @click="inverterMethods().right.dialog.exportExcel()">EXCEL
            </el-button>
          </template>
        </date-picker-with-export>
        <my-divider :height="myDividerHeight15"></my-divider>
        <el-row>
          <el-col :span="12">
            <el-radio-group v-model="right.dialog.radioGroupUIP.radioUIP" size="mini"
                            @change="inverterMethods().right.dialog.radioGroupUIP.radioUIPChange($event)">
              <el-radio-button :label="item" v-for="(item,index) in right.dialog.telemetryCategory" :key="index">
              </el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-radio-group v-model="right.dialog.radioGroupUIP.radioType" size="mini">
              <el-radio-button :label="value" v-for="(value,index) in showStyle" :key="index"></el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <my-divider :height="myDividerHeight10"></my-divider>
        <div>
          <div class="echartsBox"
               v-show="right.dialog.radioGroupUIP.radioType === showStyle.echarts && right.dialog.echarts.chartsData.xData.length > 0">
            <PublicEcharts :id="'lineBoxRight'" :chartsData="right.dialog.echarts.chartsData" :type="'lightLine'"/>
          </div>
          <div
              v-show="right.dialog.radioGroupUIP.radioType === showStyle.table && right.dialog.echarts.chartsData.xData.length > 0">
            <table class="data-table-abc" v-show="isRadioUIP(right.dialog.radioGroupUIP.radioUIP)">
              <tr>
                <td>时间</td>
                <td>{{ dataTableTitleRightAbc[0] }}</td>
                <td>{{ dataTableTitleRightAbc[1] }}</td>
                <td>{{ dataTableTitleRightAbc[2] }}</td>
              </tr>
              <tr v-for="(item, index) in right.dialog.echarts.tableData.xDataTableFiltered">
                <td>{{ item }}</td>
                <td>
                  {{
                    right.dialog.echarts.tableData.yDataTableFiltered[index][inverterMethods().right.history.getKeyArr()[0]]
                  }}
                </td>
                <td>
                  {{
                    right.dialog.echarts.tableData.yDataTableFiltered[index][inverterMethods().right.history.getKeyArr()[1]]
                  }}
                </td>
                <td>
                  {{
                    right.dialog.echarts.tableData.yDataTableFiltered[index][inverterMethods().right.history.getKeyArr()[2]]
                  }}
                </td>
              </tr>
            </table>

            <table class="data-table" v-show="!isRadioUIP(right.dialog.radioGroupUIP.radioUIP)">
              <tr>
                <td>时间</td>
                <td>{{ dataTableTitleRightSingle }}</td>
                <td>时间</td>
                <td>{{ dataTableTitleRightSingle }}</td>
              </tr>
              <tr v-for="(item, index) in right.dialog.echarts.tableData.xDataTableSingleFiltered"
                  v-if="index % 2 === 0">
                <td>{{ item }}</td>
                <td>{{ right.dialog.echarts.tableData.yDataTableSingleFiltered[index] }}</td>
                <td>{{ right.dialog.echarts.tableData.xDataTableSingleFiltered[index + 1] }}</td>
                <td>{{ right.dialog.echarts.tableData.yDataTableSingleFiltered[index + 1] }}</td>
              </tr>
            </table>
            <my-divider :height="myDividerHeight20"></my-divider>
            <div class="el-pagination-container">
              <el-pagination @size-change="inverterMethods().right.history.paging.handleSizeChange($event)"
                             @current-change="inverterMethods().right.history.paging.handleCurrentChange($event)"
                             :current-page="right.dialog.echarts.tableData.paging.currentPage"
                             :page-sizes="[10, 20, 30, 40]"
                             :page-size="right.dialog.echarts.tableData.paging.pageSize"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="right.dialog.echarts.tableData.paging.total">
              </el-pagination>
            </div>
          </div>
          <el-empty description="无数据" v-show="right.dialog.echarts.chartsData.xData.length === 0"></el-empty>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="right.dialog.dialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </el-col>
    <!-- 右边遥测值结束 -->
  </el-row>
</template>

<script>
import api from "@/api";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import MyDivider from "@/components/MyDivider";
import OmitLine from "@/components/EChartsFolder/OmitLine";
import PublicEcharts from "@/components/PublicEcharts";
import DatePickerWithExport from "@/components/zixitong/photovoltaicSystem/DatePickerWithExport";
import DataTableWithTwoColumns from "@/components/zixitong/photovoltaicSystem/DataTableWithTwoColumns";
import {judgeAuthority} from "@/assets/js/utils";

export default {
  name: "InverterInfo",
  components: {DataTableWithTwoColumns, DatePickerWithExport, PublicEcharts, OmitLine, MyDivider},
  created() {
    this.inverterMethods().getInverterData();
  },
  mounted() {
    let zh_cn_U = this.zh_cn.U;   // 电压
    let zh_cn_I = this.zh_cn.I;   // 电流
    let zh_cn_P = this.zh_cn.P;   // 功率
    let zh_cn_PF = this.zh_cn.PF;   // 功率因数
    let zh_cn_Fac = this.zh_cn.Fac;   // 频率

    let showStyleEcharts = this.showStyle.echarts;  // 图

    this.left.dialog.radioGroupUIP = {radioUIP: zh_cn_U, radioType: showStyleEcharts};
    this.left.dialog.telemetryCategory = [zh_cn_U, zh_cn_I, zh_cn_P];

    this.right.dialog.radioGroupUIP = {radioUIP: zh_cn_U, radioType: showStyleEcharts};
    this.right.dialog.telemetryCategory = [zh_cn_U, zh_cn_I, zh_cn_P, zh_cn_PF, zh_cn_Fac];

  },
  data() {
    return {
      /**
       * @description 历史数据文字
       * */
      historyText: '历史数据',
      /**
       * @description 符号和中文名称的映射
       * @description key是符号，比如电压的符号是U
       * @description value是中文名称，比如符号U对应的中文名称是电压
       * */
      zh_cn: {
        /**
         * 电压
         * */
        U: '电压',
        /**
         * 电流
         * */
        I: '电流',
        /**
         * 功率
         * */
        P: '功率',
        /**
         * 功率因数
         * */
        PF: '功率因数',
        /**
         * 频率
         * */
        Fac: '频率'
      },
      /**
       * @description A相/B相/C相
       * */
      phase: {
        /**
         * A相
         * */
        A: 'A相',
        /**
         * B相
         * */
        B: 'B相',
        /**
         * C相
         * */
        C: 'C相'
      },

      /**
       * @description 单位的前缀，有的单位前面需要空格作为前缀，比如图表的单位。
       * */
      prefixUnit: ' ',

      /**
       * @description 单位
       * @description key是符号，比如电压的符号是U
       * @description value是单位
       * */
      unit: {
        /**
         * @description 功率单位
         * */
        P: 'kw',
        /**
         * @description 电压单位
         * */
        U: 'V',
        /**
         * @description 电流单位
         * */
        I: 'A',
        /**
         * @description 频率单位
         * */
        Fac: 'Hz',
        /**
         * @description 功率因数单位
         * */
        PF: ''
      },

      dialogWidth: '50%',  // 弹窗宽度

      defaultName: '-',  // 默认名称

      format: 'YYYY-MM-DD',
      formatDateTime: 'YYYY-MM-DD HH:mm:ss',

      gutter10: 10,
      gutter30: 30,

      myDividerHeight10: "10px",
      myDividerHeight15: "15px",
      myDividerHeight20: "20px",
      myDividerHeight35: "35px",

      /**
       * @description 数据显示方式
       * */
      showStyle: {
        echarts: '图',
        table: '表'
      },

      info: {
        telemetry: {},
        attribute: {},
        attributeNameValues: [], //  用于显示属性名称/值的数组（中间部分）

        // 属性的 key-name 映射。show = true，在前端显示，show = false，不在前端显示。
        attributeKeyNameMaps: [
          {key: 'Model', name: '型号', show: true},
          {key: 'SerialNumber', name: '序列号', show: true},
          {key: 'FirmwareVersion', name: '固件版本', show: true},
          {key: 'Port', name: '端口', show: true},
          {key: 'Module', name: '模式', show: true},
          {key: 'Brand', name: '厂商', show: true},

          {key: 'InstallTime', name: '安装时间', show: false},
          {key: 'UpperAssets', name: '上级资产', show: false},
          {key: 'Num', name: this.defaultName, show: false},
          {key: 'Encode', name: this.defaultName, show: false},
          {key: 'Location', name: '位置', show: false}
        ]
      },
      left: {
        pvList: [],
        dialog: {
          dialogVisible: false,
          datePicker: {
            value: this.$moment(),
          },
          radioGroupUIP: {},
          echarts: {
            chartsData: {
              xData: ["11:00"],
              yData: [5],
              unit: "V",
            },
            tableData: {
              xDataTable: [],
              yDataTable: [],
            },
          },
          pvCurrent: {},
          menu: {
            defaultActive: "1",
          },
          telemetryCategory: [],

        },
      },
      right: {
        dialog: {
          dialogVisible: false,
          datePicker: {
            value: this.$moment(),
          },
          radioGroupUIP: {},
          echarts: {
            chartsData: {
              xData: ["01:00"],
              dataArr: [{name: "一层", data: [60]}],
              unit: "V",
            },
            tableData: {
              xDataTable: [],
              yDataTable: [],
              xDataTableFiltered: [],
              yDataTableFiltered: [],
              xDataTableSingle: [],
              yDataTableSingle: [],
              xDataTableSingleFiltered: [],
              yDataTableSingleFiltered: [],
              paging: {
                pageSize: 10,
                total: 0,
                currentPage: 1,
              },
            },
          },
          telemetryCategory: []
        },
      },
    }
  },
  methods: {
    judgeAuthority,
    /**
     * @description 判断当前选择的遥测值是否电压，电流，功率其中的一种
     * @description 因为这三种遥测值有A相，B相，C相之分，所以要单独判断
     * @param {String}radioUIP 当前选择的遥测值的中文名称
     * */
    isRadioUIP(radioUIP) {
      return radioUIP === this.zh_cn.U || radioUIP === this.zh_cn.I || radioUIP === this.zh_cn.P;
    },
    /**
     * @description 初始化为当前日期
     * */
    initDatePicker() {
      return this.$moment().format(this.format)
    },
    /**
     * @description 获取指定日期的零点时间戳。
     * @param {String} value  指定日期
     * */
    getZero(value) {
      return parseInt(this.$moment(value).startOf("day").format("x"));
    },
    /**
     * @description 获取指定日期的 23:59:59 时间戳。
     * @param  {String} value  指定日期
     * */
    getMidnight(value) {
      return parseInt(this.$moment(value).endOf("day").format("x"));
    },
    getUnit(radioUIP) {
      let unit;
      if (radioUIP === this.zh_cn.U) unit = this.unit.U;
      else if (radioUIP === this.zh_cn.I) unit = this.unit.I;
      else if (radioUIP === this.zh_cn.P) unit = this.unit.P;
      else if (radioUIP === this.zh_cn.PF) unit = "";
      else if (radioUIP === this.zh_cn.Fac) unit = this.unit.Fac;
      else unit = "";

      return unit;
    },
    inverterMethods() {
      let that = this;
      return {
        /**
         * @description 获取逆变器数据
         * */
        async getInverterData() {
          let params = {
            inverterId: that.entity.inverterId,
          };
          let res = await api.photovoltaicGetInverterData(params);
          let data = res.data.data;
          that.info.attribute = data.attribute;
          that.info.telemetry = data.telemetry;

          that.inverterMethods().middle.handleAttributeList();

          that.inverterMethods().left.handleTelemetryList();
        },

        // 左侧遥测值部分
        left: {
          /**
           * @description 处理遥测值列表（左侧部分）
           * @description 1.PV1,PV2...需要根据接口返回的数据自行计算
           * @description 2.遍历 telemetry 对象，看看有几个Vpv（1-n）
           * @description 3.将Vpv后面的数字放入 arrNumber 数组中
           * @description 4.对 arrNumber 进行排序（升序）
           * @description 5.遍历 arrNumber
           * @description 6.将数字拼接在遥测值的英文名字后面
           * */
          handleTelemetryList() {
            let prefix = 'Vpv';
            let arrNumber = [];

            let telemetry = that.info.telemetry;
            for (let key in telemetry) {
              if (key.startsWith(prefix)) {
                let arr = key.split(prefix);
                if (isNaN(Number(arr[1]))) {
                  continue;
                }
                arrNumber.push(Number(arr[1]));
              }
            }
            arrNumber.sort((a, b) => {  // 升序
              return a - b;
            });

            that.left.pvList = [];
            arrNumber.forEach((val) => {
              let pv = "PV" + val;  //PV(1-n)，PV1,PV2...
              let vpv = telemetry["Vpv" + val];   // 电压
              let pvCurr = telemetry["Pv" + val + "Curr"];  // 电流
              let ppv = telemetry["Ppv" + val];   // 功率

              let obj = {pv, vpv, pvCurr, ppv};
              that.left.pvList.push(obj);
            });
          },
          dialog: {
            handleClose(done) {
              done();
            },
            /**
             * @description 导出 Excel
             * */
            exportExcel() {
              console.log("导出数据");

              let inverterName = that.entity.inverterName;
              let stationName = that.entity.stationName;
              let xData = that.left.dialog.echarts.tableData.xDataTable;
              let yData = that.left.dialog.echarts.tableData.yDataTable;
              let radioUIP = that.left.dialog.radioGroupUIP.radioUIP;
              let unit = that.inverterMethods().left.history.getUnit();
              let dateTime = that.left.dialog.datePicker.value;
              let dateTimeFormatted = that.$moment(dateTime).format(that.format);
              let key = that.inverterMethods().left.history.getKey();

              let th = ["时间"];
              th.push(`${stationName}-${inverterName}-${radioUIP}-${unit}-${key}`);
              // 内容区
              let content = [];
              for (let i = 0; i < xData.length; i++) {
                let row = [];
                row.push(xData[i]);
                row.push(yData[i]);
                content.push(row);
              }
              exportFile.xlsxFile(
                  XLSX,
                  `${stationName}-${inverterName}-${radioUIP}-${unit}-${key}-${dateTimeFormatted}`,
                  {
                    excel: [th, ...content],
                  }
              );
            },
            menu: {
              handleOpen(key, keyPath) {
                console.log(key, keyPath);
              },
              handleClose(key, keyPath) {
                console.log(key, keyPath);
              },
              menuSelected(item) {
                console.log("菜单被点击");

                that.left.dialog.pvCurrent = item;
                that.inverterMethods().left.history.findDeviceTskv();
              },
            },
            radioGroupUIP: {
              radioUIPChange(data) {
                console.log(data);

                that.inverterMethods().left.history.findDeviceTskv();
              },
            },
          },
          history: {
            /**
             * @description 打开左侧历史数据
             * */
            openDialog() {
              console.log("打开左侧历史数据");

              that.left.dialog.dialogVisible = true;
              that.left.dialog.datePicker.value = that.initDatePicker();   // 时间初始化

              // 左侧PV列表初始化
              that.left.dialog.pvCurrent = that.left.pvList[0];
              that.left.dialog.menu.defaultActive = "1";
              if (that.$refs.menu !== undefined) {
                that.$refs.menu.activeIndex = "1";
              }

              that.left.dialog.radioGroupUIP.radioUIP = that.zh_cn.U;   // radioUIP 初始化

              that.left.dialog.radioGroupUIP.radioType = that.showStyle.echarts;   // radioType 初始化

              that.inverterMethods().left.history.findDeviceTskv();
            },
            /**
             * @description 获取遥测值的英文名，并根据不同的英文名设置不同的单位。
             * */
            getKey() {
              let key;
              let pv = that.left.dialog.pvCurrent.pv;
              let number = pv.split("PV")[1];
              let radioUIP = that.left.dialog.radioGroupUIP.radioUIP;
              if (radioUIP === that.zh_cn.U) {
                key = "Vpv" + number;
                that.left.dialog.echarts.chartsData.unit = `${that.prefixUnit}${that.unit.U}`;  // 单位前面加个空格
              } else if (radioUIP === that.zh_cn.I) {
                key = "Pv" + number + "Curr";
                that.left.dialog.echarts.chartsData.unit = `${that.prefixUnit}${that.unit.I}`; // 单位前面加个空格
              } else if (radioUIP === that.zh_cn.P) {
                key = "Ppv" + number;
                that.left.dialog.echarts.chartsData.unit = `${that.prefixUnit}${that.unit.P}`;  // 单位前面加个空格
              } else {
              }

              return key;
            },
            /**
             * @description
             * @param {String} value 子组件携带过来的日期值。
             * */
            async findDeviceTskvFromChild(value) {
              that.left.dialog.datePicker.value = value;
              await that.inverterMethods().left.history.findDeviceTskv();
            },
            async findDeviceTskv() {
              let xDataTable = [];
              let yDataTable = [];
              let xData = [];
              let yData = [];
              let keyArr = [];

              let datePickerValue = that.left.dialog.datePicker.value;
              const startTime = that.getZero(datePickerValue); // 零点时间戳
              const endTime = that.getMidnight(datePickerValue); // 23:59:59时间戳
              const key = that.inverterMethods().left.history.getKey();

              let params = {
                deviceId: that.entity.inverterId,
                startTime: startTime,
                endTime: endTime,
                keys: key,
              };
              let res = await api.photovoltaicFindDeviceTskv(params);
              let data = res.data.data;
              for (let keyTs in data) {
                keyArr.push(Number(keyTs));
              }

              keyArr.sort((a, b) => {
                return a - b;
              });

              keyArr.forEach((val) => {
                let keyDateTime = that.$moment(val).format("HH:mm");
                let keyDateTimeTable = that.$moment(val).format(that.formatDateTime);
                let value = data[val][key];

                xDataTable.push(keyDateTimeTable);
                yDataTable.push(value);
                xData.push(keyDateTime);
                yData.push(value);
              });

              that.left.dialog.echarts.chartsData.xData = xData;
              that.left.dialog.echarts.chartsData.yData = yData;

              that.left.dialog.echarts.tableData.xDataTable = xDataTable;
              that.left.dialog.echarts.tableData.yDataTable = yDataTable;
            },
            getUnit() {
              let radioUIP = that.left.dialog.radioGroupUIP.radioUIP;
              return that.getUnit(radioUIP);
            },
          },
        },
        // 中间属性部分
        middle: {

          /**
           * @description 处理属性列表（中间部分）
           * */
          handleAttributeList() {
            that.info.attributeNameValues = [];
            let attribute = that.info.attribute;
            that.attributeKeyNameMapsComputed.forEach(val => {
              for (let key in attribute) {
                let keyMap = val.key;
                if (key === keyMap) {
                  let obj = {name: val['name'], value: attribute[key]};
                  that.info.attributeNameValues.push(obj);
                }
              }
            });

          }
        },
        // 右侧遥测值部分
        right: {
          dialog: {
            handleClose(done) {
              done();
            },
            exportExcel() {
              console.log("导出数据");
              let xData;
              let yData;
              let inverterName = that.entity.inverterName;
              let stationName = that.entity.stationName;
              let unit = that.inverterMethods().right.history.getUnit();
              let dateTime = that.right.dialog.datePicker.value;
              let dateTimeFormatted = that.$moment(dateTime).format(that.format);

              let radioUIP = that.right.dialog.radioGroupUIP.radioUIP;
              if (radioUIP === that.zh_cn.U || radioUIP === that.zh_cn.I || radioUIP === that.zh_cn.P) {
                xData = that.right.dialog.echarts.tableData.xDataTable;
                yData = that.right.dialog.echarts.tableData.yDataTable;
              } else {
                xData = that.right.dialog.echarts.tableData.xDataTableSingle;
                yData = that.right.dialog.echarts.tableData.yDataTableSingle;
              }

              let th = [];
              th.push("时间");

              if (radioUIP === that.zh_cn.U || radioUIP === that.zh_cn.I || radioUIP === that.zh_cn.P) {
                th.push(`${stationName}-${inverterName}-${radioUIP}/${unit}-${that.phase.A}`);
                th.push(that.phase.B);
                th.push(that.phase.C);
              } else {
                th.push(`${stationName}-${inverterName}-${radioUIP}/${unit}`);
              }

              // 内容区
              let content = [];
              for (let i = 0; i < xData.length; i++) {
                let row = [];
                row.push(xData[i]);

                if (radioUIP === that.zh_cn.U) {
                  row.push(yData[i]["UA"]);
                  row.push(yData[i]["UB"]);
                  row.push(yData[i]["UC"]);
                } else if (radioUIP === that.zh_cn.I) {
                  row.push(yData[i]["IA"]);
                  row.push(yData[i]["IB"]);
                  row.push(yData[i]["IC"]);
                } else if (radioUIP === that.zh_cn.P) {
                  row.push(yData[i]["PA"]);
                  row.push(yData[i]["PB"]);
                  row.push(yData[i]["PC"]);
                } else {
                  row.push(yData[i]);
                }

                content.push(row);
              }
              exportFile.xlsxFile(
                  XLSX,
                  `${stationName}-${inverterName}-${radioUIP}/${unit}-${dateTimeFormatted}`,
                  {
                    excel: [th, ...content],
                  }
              );
            },
            radioGroupUIP: {
              radioUIPChange(data) {
                console.log(data);

                that.inverterMethods().right.history.findDeviceTskv();
              },
            },
          },
          history: {
            /**
             * @description 打开右侧历史数据
             * */
            openDialog() {
              console.log("打开右侧历史数据");

              that.right.dialog.dialogVisible = true;

              that.right.dialog.datePicker.value = that.initDatePicker(); // 时间初始化
              that.right.dialog.radioGroupUIP.radioUIP = that.zh_cn.U;  // radioUIP 初始化
              that.right.dialog.radioGroupUIP.radioType = that.showStyle.echarts; // radioType 初始化

              that.inverterMethods().right.history.findDeviceTskv();

            },
            async findDeviceTskvFromChild(value) {
              that.right.dialog.datePicker.value = value;
              await that.inverterMethods().right.history.findDeviceTskv();
            },
            async findDeviceTskv() {
              let keyArr = [];
              let xData = [];
              let yData = [];
              let dataA = [];
              let dataB = [];
              let dataC = [];
              let dataSingle = [];
              let xDataTable = [];
              let yDataTable = [];
              let xDataTableSingle = [];
              let yDataTableSingle = [];

              let radioUIP = that.right.dialog.radioGroupUIP.radioUIP;

              let datePickerValue = that.right.dialog.datePicker.value;
              const startTime = that.getZero(datePickerValue); // 零点时间戳
              const endTime = that.getMidnight(datePickerValue); // 23:59:59时间戳

              const keys = that.inverterMethods().right.history.getKeys();

              let params = {
                deviceId: that.entity.inverterId,
                startTime: startTime,
                endTime: endTime,
                keys,
              };
              let res = await api.photovoltaicFindDeviceTskv(params);
              let data = res.data.data;
              for (let keyTs in data) {
                keyArr.push(Number(keyTs));
              }

              keyArr.sort((a, b) => {
                return a - b;
              });

              keyArr.forEach((val) => {
                let keyDateTime = that.$moment(val).format("HH:mm");
                let keyDateTimeTable = that.$moment(val).format(that.formatDateTime);

                xDataTable.push(keyDateTimeTable);
                xDataTableSingle.push(keyDateTimeTable);
                xData.push(keyDateTime);

                if (radioUIP === that.zh_cn.U || radioUIP === that.zh_cn.I || radioUIP === that.zh_cn.P) {
                  yDataTable.push(data[val]);
                } else {
                  yDataTableSingle.push(data[val][keys]);
                }

                let keyA;
                let keyB;
                let keyC;
                let keySingle;

                if (radioUIP === that.zh_cn.U) {
                  keyA = "UA";
                  keyB = "UB";
                  keyC = "UC";
                } else if (radioUIP === that.zh_cn.I) {
                  keyA = "IA";
                  keyB = "IB";
                  keyC = "IC";
                } else if (radioUIP === that.zh_cn.P) {
                  keyA = "PA";
                  keyB = "PB";
                  keyC = "PC";
                } else if (radioUIP === that.zh_cn.Fac) {
                  keySingle = "Fac";
                } else if (radioUIP === that.zh_cn.PF) {
                  keySingle = "PF";
                }

                if (radioUIP === that.zh_cn.U || radioUIP === that.zh_cn.I || radioUIP === that.zh_cn.P) {
                  let valueA = data[val][keyA];
                  let valueB = data[val][keyB];
                  let valueC = data[val][keyC];

                  dataA.push(valueA);
                  dataB.push(valueB);
                  dataC.push(valueC);
                } else {
                  let valueSingle = data[val][keySingle];
                  dataSingle.push(valueSingle);
                }
              });

              if (radioUIP === that.zh_cn.U || radioUIP === that.zh_cn.I || radioUIP === that.zh_cn.P) {
                yData = [
                  {name: that.phase.A, data: dataA},
                  {name: that.phase.B, data: dataB},
                  {name: that.phase.C, data: dataC},
                ];
              } else if (radioUIP === that.zh_cn.Fac) {
                yData = [
                  {
                    name: that.zh_cn.Fac,
                    data: dataSingle,
                  },
                ];
              } else if (radioUIP === that.zh_cn.PF) {
                yData = [
                  {
                    name: that.zh_cn.PF,
                    data: dataSingle,
                  },
                ];
              }

              that.right.dialog.echarts.chartsData.xData = xData;
              that.right.dialog.echarts.chartsData.dataArr = yData;

              if (radioUIP === that.zh_cn.U || radioUIP === that.zh_cn.I || radioUIP === that.zh_cn.P) {
                that.right.dialog.echarts.tableData.xDataTable = xDataTable;
                that.right.dialog.echarts.tableData.yDataTable = yDataTable;

                that.right.dialog.echarts.tableData.paging.total = xDataTable.length;
                that.right.dialog.echarts.tableData.paging.pageSize = 10;
                that.right.dialog.echarts.tableData.paging.currentPage = 1;

                that.right.dialog.echarts.tableData.xDataTableFiltered = xDataTable.slice(0, that.right.dialog.echarts.tableData.paging.pageSize);
                that.right.dialog.echarts.tableData.yDataTableFiltered = yDataTable.slice(0, that.right.dialog.echarts.tableData.paging.pageSize);
              } else {
                that.right.dialog.echarts.tableData.xDataTableSingle = xDataTableSingle;
                that.right.dialog.echarts.tableData.yDataTableSingle = yDataTableSingle;

                that.right.dialog.echarts.tableData.paging.total = xDataTableSingle.length;
                that.right.dialog.echarts.tableData.paging.pageSize = 10;
                that.right.dialog.echarts.tableData.paging.currentPage = 1;

                that.right.dialog.echarts.tableData.xDataTableSingleFiltered = xDataTableSingle.slice(0, that.right.dialog.echarts.tableData.paging.pageSize);
                that.right.dialog.echarts.tableData.yDataTableSingleFiltered = yDataTableSingle.slice(0, that.right.dialog.echarts.tableData.paging.pageSize);
              }
            },
            getKeyArr() {
              let keys = that.inverterMethods().right.history.getKeys();
              return keys.split(",");
            },
            getKeys() {
              let keys;
              let radioUIP = that.right.dialog.radioGroupUIP.radioUIP;
              if (radioUIP === that.zh_cn.U) {
                keys = "UA,UB,UC";
                that.right.dialog.echarts.chartsData.unit = `${that.prefixUnit}${that.unit.U}`;
              } else if (radioUIP === that.zh_cn.I) {
                keys = "IA,IB,IC";
                that.right.dialog.echarts.chartsData.unit = `${that.prefixUnit}${that.unit.I}`;
              } else if (radioUIP === that.zh_cn.P) {
                keys = "PA,PB,PC";
                that.right.dialog.echarts.chartsData.unit = `${that.prefixUnit}${that.unit.P}`;
              } else if (radioUIP === that.zh_cn.PF) {
                keys = "PF";
                that.right.dialog.echarts.chartsData.unit = `${that.prefixUnit}${that.unit.PF}`;
              } else if (radioUIP === that.zh_cn.Fac) {
                keys = "Fac";
                that.right.dialog.echarts.chartsData.unit = `${that.prefixUnit}${that.unit.Fac}`;
              }

              return keys;
            },
            paging: {
              handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                that.right.dialog.echarts.tableData.paging.pageSize = val;
                let pageSize = val;
                let radioUIP = that.right.dialog.radioGroupUIP.radioUIP;
                if (radioUIP === that.zh_cn.U || radioUIP === that.zh_cn.I || radioUIP === that.zh_cn.P) {
                  let currentPage = that.right.dialog.echarts.tableData.paging.currentPage;
                  let xDataTable = that.right.dialog.echarts.tableData.xDataTable;
                  let yDataTable = that.right.dialog.echarts.tableData.yDataTable;

                  let startIndex = pageSize * (currentPage - 1);
                  let endIndex = startIndex + pageSize;

                  that.right.dialog.echarts.tableData.xDataTableFiltered = xDataTable.slice(startIndex, endIndex);
                  that.right.dialog.echarts.tableData.yDataTableFiltered = yDataTable.slice(startIndex, endIndex);
                } else {
                  let currentPage = that.right.dialog.echarts.tableData.paging.currentPage;
                  let xDataTableSingle = that.right.dialog.echarts.tableData.xDataTableSingle;
                  let yDataTableSingle = that.right.dialog.echarts.tableData.yDataTableSingle;

                  let startIndex = pageSize * (currentPage - 1);
                  let endIndex = startIndex + pageSize;

                  that.right.dialog.echarts.tableData.xDataTableSingleFiltered = xDataTableSingle.slice(startIndex, endIndex);
                  that.right.dialog.echarts.tableData.yDataTableSingleFiltered = yDataTableSingle.slice(startIndex, endIndex);
                }
              },
              handleCurrentChange(val) {
                console.log(`当前页: ${val}`);

                that.right.dialog.echarts.tableData.paging.currentPage = val;

                let radioUIP = that.right.dialog.radioGroupUIP.radioUIP;
                if (radioUIP === that.zh_cn.U || radioUIP === that.zh_cn.I || radioUIP === that.zh_cn.P) {
                  let pageSize = that.right.dialog.echarts.tableData.paging.pageSize;
                  let currentPage = val;
                  let xDataTable = that.right.dialog.echarts.tableData.xDataTable;
                  let yDataTable = that.right.dialog.echarts.tableData.yDataTable;

                  let startIndex = pageSize * (currentPage - 1);
                  let endIndex = startIndex + pageSize;

                  that.right.dialog.echarts.tableData.xDataTableFiltered = xDataTable.slice(startIndex, endIndex);
                  that.right.dialog.echarts.tableData.yDataTableFiltered = yDataTable.slice(startIndex, endIndex);
                } else {
                  let pageSize = that.right.dialog.echarts.tableData.paging.pageSize;
                  let currentPage = val;
                  let xDataTableSingle = that.right.dialog.echarts.tableData.xDataTableSingle;
                  let yDataTableSingle = that.right.dialog.echarts.tableData.yDataTableSingle;

                  let startIndex = pageSize * (currentPage - 1);
                  let endIndex = startIndex + pageSize;

                  that.right.dialog.echarts.tableData.xDataTableSingleFiltered = xDataTableSingle.slice(startIndex, endIndex);
                  that.right.dialog.echarts.tableData.yDataTableSingleFiltered = yDataTableSingle.slice(startIndex, endIndex);
                }
              },
            },
            getUnit() {
              let radioUIP = that.right.dialog.radioGroupUIP.radioUIP;
              return that.getUnit(radioUIP);
            },
          },
        },
      };
    },
  },
  computed: {
    /**
     * @description 电流标题
     * */
    ITitle() {
      return `${this.zh_cn.I}/${this.unit.I}`;
    },
    /**
     * @description 电压标题
     * */
    UTitle() {
      return `${this.zh_cn.U}/${this.unit.U}`;
    },
    /**
     * @description 功率标题
     * */
    PTitle() {
      return `${this.zh_cn.P}/${this.unit.P}`;
    },
    /**
     * @description 属性列表的标题（中间部分）
     * */
    attributesTitle() {
      let entity = this.entity;
      return `${entity['stationName']} - ${entity['inverterName']}`;
    },

    dataTableTitleLeft() {
      let radioUIP = this.left.dialog.radioGroupUIP.radioUIP;
      if (radioUIP === this.zh_cn.U) return this.UTitle;
      else if (radioUIP === this.zh_cn.I) return this.ITitle;
      else if (radioUIP === this.zh_cn.P) return this.PTitle;

      return "";
    },

    dataTableTitleRightAbc() {
      let PUnit = this.unit.P;    // 功率单位
      let IUnit = this.unit.I;    // 电流单位
      let UUnit = this.unit.U;    // 电压单位

      let APhase = this.phase.A;   // A相
      let BPhase = this.phase.B;   // B相
      let CPhase = this.phase.C;   // C相

      let title;

      let radioUIP = this.right.dialog.radioGroupUIP.radioUIP;
      if (radioUIP === this.zh_cn.U) title = [`${APhase}/${UUnit}`, `${BPhase}/${UUnit}`, `${CPhase}/${UUnit}`];
      else if (radioUIP === this.zh_cn.I) title = [`${APhase}/${IUnit}`, `${BPhase}/${IUnit}`, `${CPhase}/${IUnit}`];
      else if (radioUIP === this.zh_cn.P) title = [`${APhase}/${PUnit}`, `${BPhase}/${PUnit}`, `${CPhase}/${PUnit}`];
      else title = ['', '', '']

      return title;
    },

    dataTableTitleRightSingle() {
      let title;

      let zh_cn_PF = this.zh_cn.PF;
      let zh_cn_Fac = this.zh_cn.Fac;

      let radioUIP = this.right.dialog.radioGroupUIP.radioUIP;
      if (radioUIP === zh_cn_PF) title = zh_cn_PF;
      else if (radioUIP === zh_cn_Fac) title = `${zh_cn_Fac}/${this.unit.Fac}`;

      return title;
    },

    /**
     * 返回 this.info.attributeKeyNameMaps 中 show=true 的数组
     * */
    attributeKeyNameMapsComputed() {
      return this.info.attributeKeyNameMaps.filter(val => {
        return val.show
      });
    }
  },
  props: {
    entity: {
      type: Object,
      default() {
        /**
         * inverterId：逆变器id
         * inverterName：逆变器名称
         * stationName：电站名称
         * */
        return {inverterId: '', inverterName: '', stationName: ''}
      }
    }
  },
  watch: {
    'entity': {
      handler(newVal, oldVal) {
        console.log(newVal);
        console.log(oldVal);

        this.inverterMethods().getInverterData();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
$colorMain: #28cccb;
$borderColor: #eeeeee;
$trHoverBackgroundColor: #F8F9FC;

div.el-button-history-container {
  text-align: right;
}

.el-menu {
  margin-right: 25px;
}

div.el-pagination-container {
  text-align: right;
}

.el-row-refresh {
  div {
    text-align: center;
  }
}

img.ac-dc {
  width: 64px;
  height: 40px;
}

table.data-table-abc {
  text-align: center;
  border-left: 1px solid $borderColor;
  border-top: 1px solid $borderColor;
  border-spacing: 0;

  tr {
    height: 50px;

    td {
      border-bottom: 1px solid $borderColor;
      border-right: 1px solid $borderColor;
    }
  }

  tr:first-child {
    td:first-child {
      width: 35%;
    }
  }

  tr:hover {
    background-color: $trHoverBackgroundColor;
  }
}

h3.title-1 {
  text-align: center;
  height: 50px;
  line-height: 50px;
}

table.data-table {
  text-align: center;
  border-left: 1px solid $borderColor;
  border-top: 1px solid $borderColor;
  border-spacing: 0;

  tr {
    height: 50px;

    td {
      border-bottom: 1px solid $borderColor;
      border-right: 1px solid $borderColor;
    }
  }

  tr:first-child {
    td:first-child {
      width: 35%;
    }

    td:nth-child(3) {
      width: 35%;
    }
  }

  tr:hover {
    background-color: $trHoverBackgroundColor;
  }
}

div.echartsBox {
  height: 450px;
}

table.right {
  border-spacing: 0;

  tr:nth-child(n+5) {
    td:nth-child(2) {
      text-align: center;
    }
  }

  tr {
    height: 50px;

    td {
      border-bottom: 1px solid $borderColor;
    }
  }

  tr:hover {
    background-color: $trHoverBackgroundColor;
  }

  tr:first-child {
    height: 48px;

    td {
      color: #909399;
      font-weight: bold;
    }
  }
}

div.attribute {
  border: 1px solid $borderColor;
  padding: 10px;
  border-radius: 5px;
}

tr.description-1 {
  height: 35px;
}

td.name-description-1 {
  text-align: right;
  color: #666666;
  width: 140px;
}

td.separator-description-1 {
  width: 30px;
}

table {
  width: 100%;
}

.el-carouse-item-my:hover {
  cursor: pointer;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  margin-right: 10px;
}

.el-select {
  margin-right: 10px;
  width: 100px;
}
</style>

